<template>
  <div class="visa-api-page">
    <div class="visa-api-banner">
      <div class="banner-content">
        <div class="banner-content-title">签证API</div>
        <div class="banner-content-desc">上上签，签证行业领先API解决方案提供商，以自动化、数字化、智能化为方向，实现全球范围内各种签证产品的集成，办签流程的适配以及实时办理进度追踪与动态定价的行业供应链数智化解决方案。</div>
        <div class="banner-content-desc">提供签证行业全类目商品，快速嵌入到您的现有产品中，实现采购、销售、库存、资金全链路管理，数据赋能，助力企业降本增效。</div>
      </div>
    </div>
    <div class="visa-api-product">
      <div class="api-title-line">产品优势</div>
      <div class="visa-api-product-list">
        <div class="visa-api-product-item" v-for="(item,index) in productInfoList" :key="index">
          <img class="product-img" :src="item.img" alt="">
          <div class="product-title">{{item.title}}</div>
          <div class="product-dec">{{ item.desc }}</div>
        </div>  
      </div> 
    </div>
    <div class="visa-api-interface">
      <div class="api-title-line">丰富的API接口</div>
      <div class="visa-api-interface-content">
        <div class="visa-api-interface-left">
          <div class="visa-api-interface-desc">
            <div class="interface-line"></div>
            <div class="interface-desc">丰富的API接口，可实现线上签证查询、签证下单、资料提交、办理进度查询、预约、退款、结算、账单等全流程业务</div>
          </div>
        </div>
        <div class="visa-api-interface-list">
          <div class="interface-list-item" v-for="(item,index) in apiList" :key="index">
            <img class="interface-list-item-img" :src="item.img" alt="">
            <span class="interface-list-item-title">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="visa-api-cooperate">
      <div class="api-title-line">灵活多变的合作方案</div>
      <div class="visa-api-cooperate-list">
        <div class="visa-api-cooperate-item">
          <div class="cooperate-title">有开发能力</div>
          <div class="cooperate-content">
            <div class="content-item">
              <img class="content-icon" src="../assets/imgs/visa-api/icon-arrow.png">
              <span>我们提供技术接口联调</span>
            </div>
            <div class="content-item">
              <img class="content-icon" src="../assets/imgs/visa-api/icon-arrow.png">
              <span>客户自主嵌入到应用系统中</span>
            </div>
            <div class="content-item">
              <img class="content-icon" src="../assets/imgs/visa-api/icon-arrow.png">
              <span>定制化、集成化</span>
            </div>
          </div>
        </div>
        <div class="visa-api-cooperate-item">
          <div class="cooperate-title">无开发能力</div>
          <div class="cooperate-content">
            <div class="content-item">
              <img class="content-icon" src="../assets/imgs/visa-api/icon-arrow.png">
              <span>我们提供现成的解决方案</span>
            </div>
            <div class="content-item">
              <img class="content-icon" src="../assets/imgs/visa-api/icon-arrow.png">
              <span>无需额外开发</span>
            </div>
            <div class="content-item">
              <img class="content-icon" src="../assets/imgs/visa-api/icon-arrow.png">
              <span>速度快、成本低</span>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <div class="visa-api-flow">
      <div class="api-title-line">合作流程</div>
      <div class="visa-api-flow-process">
        <div class="visa-api-flow-item" v-for="(item,index) in flowList" :key="index">
          <img class="flow-item-img" :src="item.img" alt="">
          <div class="flow-item-title">{{ item.title }}</div>
          <div class="flow-item-desc" v-html="item.desc"></div>
        </div>
      </div>
      <div class="visa-api-flow-contract">
        <div class="contract-title">
          <img class="contract-title-phone" src="../assets/imgs/visa-api/icon-phone.png" alt="">
          <span class="contract-title-text">联系我们</span>
        </div>
        <div class="contract-list">
          <div class="contract-list-item">
            <div class="contract-item-title">联系人</div>
            <div class="contract-item-value">陈钰坤</div>
          </div>
          <div class="contract-list-item">
            <div class="contract-item-title">联系电话</div>
            <div class="contract-item-value">17665324339</div>
          </div>
          <div class="contract-list-item">
            <div class="contract-item-title">联系邮箱</div>
            <div class="contract-item-value">yukun.chen@idsuipai.com</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api1 from '../assets/imgs/visa-api/api-1.png';
import api2 from '../assets/imgs/visa-api/api-2.png';
import api3 from '../assets/imgs/visa-api/api-3.png';
import api4 from '../assets/imgs/visa-api/api-4.png';
import api5 from '../assets/imgs/visa-api/api-5.png';
import api6 from '../assets/imgs/visa-api/api-6.png';

import flow1 from '../assets/imgs/visa-api/flow-1.png';
import flow2 from '../assets/imgs/visa-api/flow-2.png';
import flow3 from '../assets/imgs/visa-api/flow-3.png';
import flow4 from '../assets/imgs/visa-api/flow-4.png';

import goods1 from '../assets/imgs/visa-api/goods-1.png';
import goods2 from '../assets/imgs/visa-api/goods-2.png';
import goods3 from '../assets/imgs/visa-api/goods-3.png';
import goods4 from '../assets/imgs/visa-api/goods-4.png';
import goods5 from '../assets/imgs/visa-api/goods-5.png';
import goods6 from '../assets/imgs/visa-api/goods-6.png';

export default {
  data() {
    return {
      productInfoList: [
        {
          img: goods1,
          title: '全球签证覆盖',
          desc: '覆盖全球104个国家，支持全国各领区在线办理，出境签证类型齐全',
        },
        {
          img: goods2,
          title: '灵活的办签流程',
          desc: '适应各国不同的签证办理流程，能够根据目的地的特点获得定制化的服务',
        },
        {
          img: goods3,
          title: '实时办理进度追踪',
          desc: '提供实时的签证办理进度追踪功能，整体办签进度清晰可见',
        },
        {
          img: goods4,
          title: '动态定价',
          desc: '签证一手价格，市场实时价格更新，提升透明度与信任',
        },
        {
          img: goods5,
          title: '供应链优化',
          desc: '解决签证供应链的问题，降低中间环节的复杂性，使您专注于核心业务',
        },
        {
          img: goods6,
          title: '轻松嵌入产品',
          desc: '不影响现有用户使用，轻松地将签证API嵌入到现有产品中',
        },
      ],
      apiList: [
        {
          title: '签证API',
          img: api1,
        },
        {
          title: '订单API',
          img: api2,
        },
        {
          title: '资料API',
          img: api3,
        },
        {
          title: '进度API',
          img: api4,
        },
        {
          title: '预约API',
          img: api5,
        },
        {
          title: '账单API',
          img: api6,
        },
      ],
      flowList: [
        {
          img: flow1,
          title: '提出需求 商务对接',
          desc: '客户提出需求<br/>商务给出专业的方案',
        },
        {
          img: flow2,
          title: '评估沟通 确认需求',
          desc: '评估最终定制方案<br/>确认报价明细',
        },
        {
          img: flow3,
          title: '技术支持 开发测试',
          desc: '快速研发需求<br/>高质量测试验收',
        },
        {
          img: flow4,
          title: '上线使用 售后支持',
          desc: '专业研发团队在线答疑<br/>全方位售后支持',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.visa-api-page{
  margin-top: -68px;
  .api-title-line{
    position: relative;
    color: #2F333D;
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 52px;
    text-align: center;
    &::after{
      content: ' ';
      width: 80px;
      height: 8px;
      background: linear-gradient(270deg, rgba(89,159,255,0) 0%, rgba(89,159,255,0.8) 50%, rgba(89,159,255,0) 100%);
      opacity: 0.8;
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .visa-api-banner{
    width: 100%;
    height: 547px;
    background: url(../assets/imgs/visa-api/banner.jpg) no-repeat;
    background-size: cover;
    background-position:bottom;
    .banner-content{
      width: 720px;
      margin-left: 22%;
      padding-top: 100px;
      color: #fff;
    }
    .banner-content-title{
      font-size: 56px;
      margin-bottom: 40px;
      font-weight: bold;
    }
    .banner-content-desc{
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 20px;
    }
  }
  .visa-api-product{
    background-color: #FAFBFC;
    padding: 80px 0 50px 0;
  }
  .visa-api-product-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 1120px;
    margin: 0 auto ;
    
  }
  .visa-api-product-item{
    width: 353px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #E9EEF2;
    padding: 48px 46px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    .product-img{
      width: 108px;
    }
    .product-title{
      font-size: 24px;
      line-height: 33px;
      color: #2F333D;
      margin-bottom: 20px;
    }
    .product-dec{
      color: #91999F;
      font-size: 16px;
      line-height: 24px;
    }
  }
  .visa-api-interface{
    width: 100%;
    padding: 80px 0 112px 0;
    background: linear-gradient(180deg, #FFFFFF 0%, #F3F7FF 100%);
    .api-title-line{
      margin-bottom: 60px;
    }
  }
  .visa-api-interface-content{
    width: 1120px;
    margin: 0 auto;
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
  }
  .visa-api-interface-left{
    background: url(../assets/imgs/visa-api/api-bg.png) no-repeat;
    width: 455px;
    height: 280px;
    position: relative;
  }
  .visa-api-interface-desc{
    width: 352px;
    padding: 32px;
    background: linear-gradient(270deg, #599FFF 0%, #4083FF 100%);
    border-radius: 2px;
    opacity: 0.9;
    position: absolute;
    left: -20px;
    bottom: -32px;
    color: #fff;
    .interface-line{
      width: 18px;
      height: 4px;
      background: #FFFFFF;
      margin-bottom: 12px;
    }
    .interface-desc{
      font-size: 16px;
      line-height: 24px;
    }
  }
  .visa-api-interface-list{
    width: 549px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .interface-list-item{
    display: flex;
    align-items: center;
    .interface-list-item-img{
      width: 60px;
      height: 60px;
    }
    .interface-list-item-title{
      font-size: 20px;
      line-height: 32px;
      margin-left: 12px;
    }
  }
  .visa-api-cooperate{
    background: #fff;
    padding: 80px 0 100px 0;
    .api-title-line{
      margin-bottom: 60px;
    }
  }
  .visa-api-cooperate-list{
    width: 1120px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .visa-api-cooperate-item{
    width: 545px;
    padding: 40px 0 54px 60px;
    background: url(../assets/imgs/visa-api/cooperate-1.png) no-repeat;
    background-size: cover;
    &:last-child{
      background-image: url(../assets/imgs/visa-api/cooperate-2.png);
    }
    .cooperate-title{
      color: #2F333D;
      font-size: 28px;
      line-height: 40px;
      margin-bottom: 20px;
    }
    .cooperate-content{
      color: #2F333D;
      font-size: 16px;
      line-height: 18px;
    }
    .content-item{
      margin-bottom: 16px;
    }
    .content-icon{
      width: 12px;
      height: 12px;
      margin-right: 3px;
    }
  }
  .visa-api-flow{
    padding: 80px 0 100px 0;
    background: linear-gradient(180deg, #F2F6FE 0%, #FFFFFF 100%);
  }
  .visa-api-flow-process{
    width: 1120px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    box-shadow: 0px 4px 16px 0px rgba(154,197,255,0.32);
    border-radius: 2px;
  }
  .visa-api-flow-item{
    width: 280px;
    padding: 42px 0 78px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .flow-item-img{
      width: 103px;
      height: 102px;
      margin-bottom: 32px;
    }
    .flow-item-title{
      color: #2F333D;
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 12px;
    }
    .flow-item-desc{
      color: #91999F;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
  }
  .visa-api-flow-contract{
    width: 1152px;
    padding: 47px 0 54px 0;
    background: url(../assets/imgs/visa-api/contract-bg.png) no-repeat;
    background-size: 100%;
    display: flex;
    align-items: center;
    margin: 0 auto;
    .contract-title{
      display: flex;
      padding: 11px 27px 12px 27px;
      background-color: #fff;
      background: #FFFFFF;
      box-shadow: 0px 4px 16px 0px rgba(154,197,255,0.32);
      border-radius: 28px;
      margin-left: 128px;
      align-items: center;
      .contract-title-phone{
        width: 22px;
        height: 22px;
        margin-right: 6px;
      }
      .contract-title-text{
        font-size: 24px;
        line-height: 33px;
        color: #2F333D;
      }
    }
    .contract-list{
        margin-left: 200px;
        display: flex;
      }
      .contract-list-item{
        margin-right: 60px;
        font-size: 16px;
        line-height: 22px;
      }
      .contract-item-title{
        color: #91999F;
        margin-bottom: 4px;
      }
      .contract-item-value{
        color: #2F333D;
      }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/VisaApi.vue